import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const [sp] = useSearchParams();
  const aid = sp.get("appointment_id");
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAF7F2] grid place-content-center p-6">
      <div className="max-w-md bg-white rounded-3xl border border-[#E5DCCE] p-8 text-center shadow-sm">
        <div className="w-16 h-16 rounded-full grid place-content-center mx-auto bg-rose-100 text-rose-600">
          <XCircle className="w-8 h-8"/>
        </div>
        <h1 className="font-display text-3xl font-bold mt-4">Payment cancelled</h1>
        <p className="text-sm text-[#6B625B] mt-2">No worries — you can try again anytime.</p>
        <div className="flex gap-2 justify-center mt-6">
          {aid && (
            <Button onClick={() => nav(`/pay/${aid}`)} className="rounded-full bg-[#C85A17] hover:bg-[#A9480F]" data-testid="btn-retry-pay">
              Try again
            </Button>
          )}
          <Button variant="outline" onClick={() => nav("/client")} className="rounded-full" data-testid="btn-pay-cancel-home">
            Back to home
          </Button>
        </div>
      </div>
    </div>
  );
}
